// import Repository from '@/libs/axios'
import OperationRepository from '@/libs/customAxios/operationAxios'

const resource = '/merchant/setting'
const noAuthresource = '/settings/business'
const rateCard = '/merchant/rate-card'
// const aiSetting = '/merchant/setting/ai-settings'

export default {
  getMerchantSettigs() {
    return OperationRepository.get(`${resource}`)
  },
  getBusinessSettigs() {
    return OperationRepository.get(`${noAuthresource}`)
  },
  getAISettigs(payload) {
    return OperationRepository.put(`${resource}/ai-settings`, payload)
  },
  setMerchantSettigs(payload) {
    return OperationRepository.put(`${resource}`, payload)
  },
  getMerchantRateCard() {
    return OperationRepository.get(`${rateCard}`)
  },
}
